import { render } from "./LegendaEstadoSprint.vue?vue&type=template&id=8c90490c&scoped=true"
import script from "./LegendaEstadoSprint.vue?vue&type=script&lang=js"
export * from "./LegendaEstadoSprint.vue?vue&type=script&lang=js"

import "./LegendaEstadoSprint.vue?vue&type=style&index=0&id=8c90490c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c90490c"]])

export default __exports__